import React, { useEffect, useRef, useState } from 'react'
import { Button, Divider, Form, Header, Modal } from 'semantic-ui-react'
import { useTextResources, useMessageResources } from '../../language'
import PropTypes from "prop-types";
import { onError, onWarning } from '../shared/messages';
import SavedCardsList from './savedCardsList';
import AuthorizationsList from './authorizationsList';
import { PaymentDialog } from './paymentDialog'
import { CreateTokenDialog } from './createTokenDialog'
import saveAs from 'file-saver'
import './style.css'
import { GetFolios } from '../../api/services/finance';
import { EntityType, EntityTypes } from '../shared/constants';
import _ from 'lodash'
import ValidateModalPermission from '../shared/ValidateModalPermission';
import { PermissionsActions } from '../shared/permissionsActions';
import { hasDigitalCertificate } from '../shared/utils';
import { defaultAllowedPaymentProviderIDs } from './paymentCommon';
import { useLoader } from '../../hooks/useLoader';

//Not in use, consider to delete AddCardPopup
export const AddCardPopup = ({ onClose, reservation: initialReservation, hotelid, controller, startOpen, ...rest }) => {
    const text = useTextResources()
    const message = useMessageResources()
    const dialogRef = useRef()
    const { formProps } = rest
    const [open, setOpen] = useState(startOpen)
    const [reservation, setReservation] = useState(initialReservation)
    const [params, setParams] = useState()
    const [folios, setFolios] = useState([])
    const [entity, setEntity] = useState(3)
    hotelid = reservation ? reservation.HotelId : hotelid

    useEffect(() => {
        setOpen(startOpen)
    }, [startOpen])


    useEffect(() => {
        setReservation(initialReservation)
    }, [initialReservation])

    useEffect(() => {
        if (reservation) {
            (async () => {
                try {
                    const folios = await GetFolios({
                        HotelID: hotelid,
                        EntityIDs: [reservation.Id],
                        EntityTypeIDs: [EntityType.Reservation],
                        IncludeOwner: true,
                        IncludeFolioEntities: true,
                    })
                    setFolios(folios)
                } catch (error) {
                    onError(error)
                }
            })()
        }
    }, [reservation])

    useEffect(() => {
        if (controller) {
            window[controller] = (action, params) => {
                switch (action) {
                    case "open":
                        if (params) {
                            setReservation(params.reservation)
                            setParams(params)
                        } else {
                            setReservation(null)
                            setParams(null)
                        }
                        setOpen(true)
                        break;
                    default:
                        break;
                }
            }
        }
    }, [])


    const getFolioId = () => {
        if (reservation && reservation.FolioId) {
            return reservation && reservation.FolioId
        } else if (folios && folios.length) {
            const folio = folios.find(x => x.Owner && x.Owner.EntityTypeId === entity)
            return folio && folio.Id
        } else {
            console.warn("Folio could not be found")
        }
    }

    const closeAction = () => {
        if (onClose) onClose()
        setOpen(false)
    }

    const saveAction = async () => {
        (async () => {
            try {
                if (!(await hasDigitalCertificate())) {
                    return onWarning(message("MissingPermissionsForDigitalInvoice"));
                }

                if (dialogRef.current) {
                    const result = await dialogRef.current.saveAction()
                    if (params && params.onSave) params.onSave(result)
                    window.postMessage({
                        type: "CreditCardsUpdated"
                    })
                    if (onClose) onClose()
                }
                setOpen(false)
            } catch (error) {
                onWarning(error)
            }
        })()
    }

    const entities = () => {
        const result = []
        if (reservation) {
            result.push({ type: 1, id: reservation.Id })
            if (folios) {
                const owner = folios.map(x => x.Owner).find(x => x.EntityTypeId === entity)
                if (owner) {
                    result.push({ type: owner.EntityTypeId, id: owner.EntityId })
                }
            }
        }
        return result
    }


    const getAvailableEntities = () => {
        let result = []
        if (folios) {
            const etypes = _.uniq(folios.map(x => x.Owner.EntityTypeId))
            result = etypes.map(t => ({
                text: text(EntityTypes[t]),
                value: t
            }))
        }
        return result
    }
    const availableEntities = getAvailableEntities()

    return <Modal className="payment-popup" size="tiny" open={open} {...rest} >
        <Modal.Header>{text("AddCreditCard")}</Modal.Header>
        <Modal.Content>
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <SavedCardsList reservation={reservation} header={<Header dividing as='h4'>{text("SavedCreditCards")}</Header>} footer={<Divider />} />
                <AuthorizationsList reservation={reservation} header={<Header dividing as='h4'>{text("SavedAuthorizations")}</Header>} footer={<Divider />} />
            </div>
            {(availableEntities.length !== 0) && <Form style={{ marginBottom: 10 }}>
                <Form.Select label={text("Entity")} options={availableEntities} value={entity} onChange={(e, { value }) => setEntity(value)} />
            </Form>}
            <CreateTokenDialog ref={dialogRef} HotelId={hotelid} entities={entities()} folioId={getFolioId()} {...formProps}></CreateTokenDialog>
        </Modal.Content>
        <Modal.Actions>
            <Button negative size="small" onClick={closeAction}> {text("Close")}</Button>
            <Button positive size="small" onClick={saveAction}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal>
}

export const MakePaymentPopup = ({ onClose, reservation: initialReservation, hotelid, controller, startOpen, actionId, ...rest }) => {
    const text = useTextResources();
    const message = useMessageResources()
    const dialogRef = useRef();
    const [formProps, setFormProps] = useState(rest.formProps);
    const [_open, setOpen] = useState(startOpen);
    const [reservation, setReservation] = useState(initialReservation);
    const [params, setParams] = useState();
    const [isSaving, setIsSaving] = useState(false);
    const [displaySave, setDisplaySave] = useState(true);
    const loader = useLoader();

    useEffect(() => {
        setOpen(startOpen)
    }, [startOpen])


    useEffect(() => {
        setReservation(initialReservation)
    }, [initialReservation])

    useEffect(() => {
        if (controller) {
            window[controller] = (action, params) => {
                switch (action) {
                    case "open":
                        if (params) {
                            setReservation(params.reservation)
                            setFormProps(params.formProps)
                            setParams(params)
                        } else {
                            setReservation(null)
                            setParams(null)
                        }
                        setOpen(true)
                        break;
                    default:
                        break;
                }
            }
        }
    }, [])

    hotelid = reservation ? reservation.HotelId : hotelid

    const closeAction = () => {
        if (onClose) onClose()
        setOpen(false)
    }
    const actions = [
        {
            text: text("SaveCreditCard"),
            value: 1
        }, {
            text: text("TakeAuthorization"),
            value: 2
        }, {
            text: text("TakePayment"),
            value: 4
        }
    ]

    const action = actions.find(x => x.value === rest.defaultAction)

    const saveAction = async () => {
        (async () => {
            try {
                if (!(await hasDigitalCertificate())) {
                    return onWarning(message("MissingPermissionsForDigitalInvoice"));
                }

                if (dialogRef.current) {
                    const result = await dialogRef.current.saveAction();
                    loader(true);
                    setIsSaving(true);
                    if (result?.PathOriginal) {
                        saveAs(result.PathOriginal);
                    }
                    if (result?.PathCopy) {
                        saveAs(result.PathCopy);
                    }
                    if (params && params.onSave) params.onSave(result)
                    window.postMessage({
                        type: "CreditCardsUpdated"
                    })
                    if (onClose) onClose(result)
                    setOpen(false);
                }
            } catch (error) {
                error.status === 400 ? onWarning(error) : onError(error);
            } finally{
                setIsSaving(false)
                setDisplaySave(true);
                loader(false)
            }
        })()
    }

    return (
        <ValidateModalPermission
            open={_open}
            onClose={onClose}
            actionId={actionId || PermissionsActions.AccessSaveCardAuthorization}>
            <Modal className="payment-popup" open={_open} size="tiny" {...rest} >
                <Modal.Header>{(action && action.text) || text("Payment")}</Modal.Header>
                <Modal.Content style={{ minHeight: 480 }}>
                    <PaymentDialog
                        ref={dialogRef}
                        HotelId={hotelid}
                        reservation={reservation}
                        allowedPaymentProviderIDs={defaultAllowedPaymentProviderIDs}
                        {...formProps}
                        {...rest}>
                    </PaymentDialog>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative size="small" onClick={closeAction}> {text("Close")}</Button>
                    <Button positive size="small" onClick={saveAction} disabled={isSaving}>{text("Save")}</Button>
                </Modal.Actions>
            </Modal>
        </ValidateModalPermission>)
}


AddCardPopup.propTypes = {
    onClose: PropTypes.func,
    reservation: PropTypes.any,
    hotelid: PropTypes.any,
    startOpen: PropTypes.bool,
    controller: PropTypes.string
}

MakePaymentPopup.propTypes = {
    onClose: PropTypes.func,
    reservation: PropTypes.any,
    hotelid: PropTypes.any,
    startOpen: PropTypes.bool,
    controller: PropTypes.string,
    actionId: PropTypes.any
}
